/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://dge2fldn7fgs3ozms6shn3clqq.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-pwxeq4lrzvbfnarmoe3nb5udke",
    "aws_cloud_logic_custom": [
        {
            "name": "mobRestAPI",
            "endpoint": "https://qcjj7cgmk7.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
